import store from '@/store'
export function dict(value,valName, s) {//字典兑换值
    let dictionary = store.state.user.dictionary[valName]
    if(value && dictionary) {
        if(typeof value == 'string') {
            return dictionary[value] ? dictionary[value].name : ''
        }else {
            return value.map(item => {
                return dictionary[item] ? dictionary[item].name : ''
            }).join(s ? s : ',')
        }
    }
}
export function dictVal(val,valName, s) {//字典兑换其他值val
    let dictionary = store.state.user.dictionary[valName]
    if(val && typeof val == 'string') {
        return dictionary[val] ? dictionary[val].value : ''
    }else if(val){
        return val.map(item => {
            return dictionary[item] ? dictionary[val].value : ''
        }).join(s ? s : ',')
    }else{
        return '未知'
    }
}
export function dictArr(category) {//字典值
    return  store.state.user.dictionaryObj[category]
    // if(dictionary){
    //     const resultArray = Object.entries(dictionary).map(([key, value]) => {
    //         return {
    //             code: key,
    //             name: value
    //         }
    //     })
    //     return resultArray
    // }else{
    //     return []
    // }

}



